let _ = t => t,
  _t;
import { css } from 'styled-components';
import { cssVar } from '@ovpn-ui/utils';
import { sidebarAnimation } from './Sidebar/Sidebar.constants';
export function setTopOffset(offset) {
  cssVar.setNumber('--sidebar-top-offset', offset);
}
export function getTopOffset() {
  return cssVar.getNumber('--sidebar-top-offset');
}
export function opacityBlur(transition = `opacity ${sidebarAnimation}`) {
  return css(_t || (_t = _`
        opacity: ${0};

        transition: ${0};
    `), t => t.$open ? 1 : 0, transition);
}